<template lang="pug">
section.upload-lote(id='cadastro-lote')
    h3.upload-lote__title Ingresar persona por lote

    div.upload-lote__card
        div.upload-lote__info
            span.upload-lote__description Para agilizar el proceso, puedes añadir a más de una persona a la vez utilizando una hoja de cálculo.
            span.upload-lote__subtitle La planilla debe contener los siguientes campos:

        div.dropzone
            div.upload-lote__fields-container
                ul.upload-lote__fields-list
                    li.upload-lote__fields-item País
                    li.upload-lote__fields-item-obg Nombre o Razon Social
                    li.upload-lote__fields-item-obg CUIT
                    li.upload-lote__fields-item E-mail
                    li.upload-lote__fields-item Telefono
                    li.upload-lote__fields-item-obg Provincia
                    li.upload-lote__fields-item-obg Departamento
                    li.upload-lote__fields-item-obg Localidad
                    li.upload-lote__fields-item Codigo Unico Empresa

            div.dropzone__box
                el-upload(
                    action='#'
                    :auto-upload='false'
                    :on-change='enviarPlanilha'
                    :on-exceed='onExceed'
                    :file-list='fileList'
                    :limit='1'
                    drag
                    ref='uploadPlanilhaCadastrarPessoa'
                )
                    i.el-icon-upload
                    div.el-upload__text
                        | Arrastre el archivo aquí o
                        em haga clic para subir

                div.dropzone__download-link
                    span.btn-download(@click='downloadPlanilhaExemplo()')
                        i.mdi.mdi-download
                        span Descargar modelo de hoja de cálculo

        template(v-if='dadosLote.status')
            DadosLote(:dadosLote='dadosLote' @loteConfirmado="$emit('buscarResultadoLote')")
</template>

<script>
import DadosLote from './dados-lote/index.vue';
import PessoaServiceArgentina from '@/services/PessoaServiceArgentina.js';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

export default {
    name: 'index',
    components: {
        DadosLote
    },

    data() {
        return {
            fileList: [],
            messages: [],
            dadosLote: {
                id: 123,
                planilha: '',
                planilhaErro: false,
                dataCadastro: '',
                dataAtualizacao: '',
                status: ''
            }
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    mounted() {
        this.buscarDadosLote();
        this.conectarCanalNotificacaoProcessamento();
    },

    beforeDestroy() {
        disconnect();
    },

    methods: {
        async enviarPlanilha(planilha) {
            if (
                this.dadosLote.status === 'EM_PROCESSAMENTO'
            ) {
                this.$notify.warning({
                    message: 'No es posible crear un nuevo registro, ya que hay uno en trámite.'
                });
                this.$refs.uploadPlanilhaCadastrarPessoa.clearFiles();
                return false;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({message: 'Este archivo es mayor de 15 MB.'});

                this.$refs.uploadPlanilhaCadastrarPessoa.clearFiles();
                return false;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();

            if (extension !== 'xlsx') {
                this.$notify.error({ message: 'Solo se admiten archivos con la extensión XLSX.'});

                this.$refs.uploadPlanilhaCadastrarPessoa.clearFiles();
                return false;
            }

            try {
                this.$notify.success({ message: 'El archivo se está enviando'});

                await PessoaServiceArgentina.cadastrarViaPlanilha(planilha);
                this.$notify.success({
                    message: 'Archivo enviado con éxito. El procesamiento se completará pronto'
                });

                this.buscarDadosLote();
            } catch (error) {
                this.$notify.error({ message: 'Error al cargar el archivo'});
            }
            this.$refs.uploadPlanilhaCadastrarPessoa.clearFiles();
        },

        onExceed() {
            this.$notify.warning({
                message: 'Solo se permite la carga de un archivo a la vez',
                position: 'top-left'
            });
        },

        downloadPlanilhaExemplo() {
            let link = document.createElement('a');

            link.href = 'https://lyra-bunge-publico.s3.us-east-1.amazonaws.com/planilla_ejemplo_personas_en_lote_AR.xlsx';

            link.setAttribute('download', 'planilha-ejemplo-persona.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        factoryDadosLote(lote) {
            const {
                id,
                planilha,
                planilhaErro,
                dataCadastro,
                dataAtualizacao,
                status
            } = lote;

            return {
                id,
                planilha,
                planilhaErro,
                dataCadastro,
                dataAtualizacao,
                status
            };
        },

        async buscarDadosLote() {
            try {
                const { data } =
                    await PessoaServiceArgentina.buscarDadosLoteCadastroViaPlanilha();
                if (data) {
                    this.dadosLote = this.factoryDadosLote(data);
                }
            } catch (error) {
                this.$notify.error(
                    this.$t({message: 'Error al buscar datos de procesamiento'})
                );
            }
        },

        async conectarCanalNotificacaoProcessamento() {
            try {
                await connect();
            } catch {
                this.$notify.error('No se pudo conectar a la API');
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/lote/ar/pessoa/cadastro-argentina`,
                    response => {
                        this.dadosLote = this.factoryDadosLote(JSON.parse(response));
                        this.$notify.success('El procesamiento ha sido actualizado');
                        this.$emit('buscarResultadoLote');
                    }
                );
            } catch (error) {
                disconnect();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.upload-lote {
    span, p, li {
        color: #303133;
    }

    &__title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }

    &__info {
        .upload-lote__subtitle, .upload-lote__description {
            display: block;
        }
    }

    &__card {
        background-color: #FFFFFF;
        border: 1px solid #EBEEF5;
        padding: 20px;
        border-radius: 10px;

        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .dropzone {
        display: flex;

        .upload-lote__fields-container {
            .upload-lote__fields-list {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                width: 500px;

                li.upload-lote__fields-item-obg::after {
                    content: " *";
                    color: #f56c6c;
                }
            }
        }

        .dropzone__box {
            width: 100%;
            i {
                color: var(--primary);
                font-size: 30px;
            }

            .dropzone__download-link {
                display: flex;
                justify-content: flex-end;
                gap: 15px;
                align-items: center;

                width: 100%;

                .btn-download {
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    font-weight: 600;
                    i {
                        font-size: 15px;
                    }
                    span {
                        text-decoration: underline;
                        color: var(--primary);
                    }
                }
            }
        }
    }

    .el-upload-dragger:hover {
        border-color: var(--primary);
    }
}

::v-deep .el-upload-dragger {
    background-color: #f2f2f2 !important;
}

.dropzone__box {
    ::v-deep .el-upload-dragger:hover {
        border-color: var(--primary);
    }
}
</style>
